import { useEffect } from 'react';

// A relative in-app path only: `//evil.example` and absolute URLs would turn
// this handoff into an open redirect.
const safeReturnPath = (from: string | null): string =>
  from && from.startsWith('/') && !from.startsWith('//') ? from : '/';

export default function KoobAuthRedirect() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const accessToken = params.get('accessToken');
    const refreshToken = params.get('refreshToken');

    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
    }
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }

    // replace() keeps the token-bearing URL out of browser history. `from` is
    // the page the other app was asked for before it bounced the user here
    // (MCP consent, deep links).
    window.location.replace(safeReturnPath(params.get('from')));
  }, []);

  return null;
}
